import { render, staticRenderFns } from "./officialAccQrcode.vue?vue&type=template&id=70730bca&scoped=true&"
import script from "./officialAccQrcode.vue?vue&type=script&lang=js&"
export * from "./officialAccQrcode.vue?vue&type=script&lang=js&"
import style0 from "./officialAccQrcode.vue?vue&type=style&index=0&id=70730bca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70730bca",
  null
  
)

component.options.__file = "officialAccQrcode.vue"
export default component.exports